import ProxyBase from '../../ProxyBase';
import ServiceProxyConfig from '../../../../configs/ServiceProxyConfig';

class AlertProxy extends ProxyBase {
  getAllSystemAlerts(data) {
    return this.get('Alert/GetAllSystemAlerts', data);
  }

  subscribeSystemAlert(data) {
    return this.post('Alert/SubscribeSystemAlert', data);
  }

  getNotificationList(data) {
    return this.get('Alert/GetNotificationList', data);
  }

  getPersonalAlertTypes(data) {
    return this.get('PersonalAlert/GetPersonalAlertTypes', data);
  }

  getPersonalSubsribedAlerts() {
    return this.get('PersonalAlert/GetPersonalSubsribedAlerts');
  }

  addPersonalAlert(data) {
    return this.post('PersonalAlert/AddPersonalAlert', data);
  }

  editPersonalAlert(data) {
    return this.post('PersonalAlert/EditPersonalAlert', data);
  }

  activePersonalAlert(data) {
    return this.post('PersonalAlert/ActivePersonalAlert', data);
  }

  removePersonalAlert(data) {
    return this.post('PersonalAlert/RemovePersonalAlert', data);
  }
}

const alertCommonProxy = new AlertProxy(
  ServiceProxyConfig.Tools.Alerts.ServiceUrl,
);
export default alertCommonProxy;
